/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { connect } from "react-redux";
import { compose, AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { t } from "i18n";

import { saveCollectionConfig } from "../async-action-creators";
import Button from "components/button/button";
import Header from "components/header/header";
import { PartialAppState } from "../state";
import { CollectionsConfig } from "api/collection-config";

interface StateProps {
  collectionsConfig: CollectionsConfig | null;
  isCollectionsConfigModified: boolean;
}

interface DispatchProps {
  saveConfig: (collectionsConfig: CollectionsConfig) => void;
}

type Props = StateProps & DispatchProps;

class CollectionConfigureHeader extends React.Component<Props> {
  render() {
    const { saveConfig, collectionsConfig, isCollectionsConfigModified } = this.props;
    return (
      <React.Fragment>
        <Header>
          {collectionsConfig && isCollectionsConfigModified && (
            <Button variant="success" type="primary" onClick={() => saveConfig(collectionsConfig)}>
              {t("save")}
            </Button>
          )}
        </Header>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: PartialAppState): StateProps => {
  return {
    collectionsConfig: state.collectionsConfig,
    isCollectionsConfigModified: state.collectionsConfig.isCollectionConfigModified
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<PartialAppState, void, AnyAction>): DispatchProps => {
  return {
    saveConfig: (collectionsConfig) => dispatch(saveCollectionConfig(collectionsConfig))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CollectionConfigureHeader);

export { CollectionConfigureHeader };
